import { Breadcrumb, Button, Card, Col, Dropdown, Flex, Layout, Row, Select, Space, Table, Tabs } from "antd";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";

import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import dayjs from "dayjs";
import TableAntd from "components/elements/Table/Table";
import FormItem from "antd/es/form/FormItem";
import { ReactComponent as DownloadICon } from "../../../assets/icon/downloadIcon.svg";
import WorkingTimeModal from "./reportModal/WorkingTimeModal";
import { DownloadOutlined, MoreOutlined } from "@ant-design/icons";
import TabPane from "antd/es/tabs/TabPane";

const WorkingTimeGroupComponent = ({
    showReport,
    employeeOptions = [],
    reportTableWoringTime = [],
    reportTableWoringTime2 = [],
    employeeStatusTypeOptions = [],
    initialValues,
    onChange = () => { },
    onChange2 = () => { },
    pagination = {},
    pagination2 = {},
    departmentOptions = [],
    positionOptions = [],
    workInLocationList = [],
    handleSearch = () => { },
    exportWorkingTimeGroupReport = () => { },
    exportWorkingTimeGroupReportAll = () => { },
    isModalOpen = false,
    setIsModalOpen = () => { },
    showModal = () => { },
    isDownloading = false,
    isDownloadingTA = false,
    exportTimeAttendanceReport = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const currentYear = new Date().getFullYear().toString();
    function formatDate(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/BBBB HH:mm`);
    }

    function formatTime(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "HH:mm" : `HH:mm น.`);
    }
    const columns = [
        {
            title: <div className="text-table">{t('common.index')}</div>,
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 100,
            render: (_, record, idx) => {
                return <span style={{ color: "#667085" }}>{(pagination.pageNo - 1) * pagination.size + idx + 1}</span>;
            },

        },
        {
            title: <div className="text-table">{t('employee.label.employee_id')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "center",
            width: 150,
            render: (_, record) => {
                return record.employeeInfo.employeeNo;
            },
        },
        {
            title: <div className="text-table">{t('employee.label.name')}</div>,
            dataIndex: "employeeInfo",
            key: "employeeInfo",
            align: "center",
            width: 150,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record.employeeInfo.employeeFullNameEn;
                }
                return record.employeeInfo.employeeFullName;
            },

        },
        {
            title: <div className="text-table">{t('workin_location.label.department')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.departmentModel?.nameEn ? record?.departmentModel?.nameEn : "-";
                }
                return record?.departmentModel?.name ? record?.departmentModel?.name : "";
            },
        },
        {
            title: <div className="text-table">{t('position.header')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.position?.nameEn ? record?.position?.nameEn : "-";
                }
                return record?.position?.name ? record?.position?.name : "";
            },
        },
        {
            title: <div className="text-table">{t('branch.entity')}</div>,
            dataIndex: "branchInformation",
            key: "branchInformation",
            align: "left",
            width: 150,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.branchInformation?.nameEn;
                }
                return record?.branchInformation?.name;

            },
        },
        {
            title: <div className="text-table">{t('check-in-date')}</div>,
            dataIndex: "checkInDatetime",
            key: "checkInDatetime",
            align: "center",
            width: 150,
            render: (_, record) => {
                return record?.checkInDatetime ? formatDate(record?.checkInDatetime) : "-";
            },

        },
        {
            title: <div className="text-table">{t('check-out-date')}</div>,
            dataIndex: "checkOutDatetime",
            key: "checkOutDatetime",
            align: "center",
            width: 150,
            render: (_, record) => {
                return record?.checkOutDatetime ? formatDate(record?.checkOutDatetime) : "-";
            },

        },
        {
            title: "",
            key: "action",
            align: "center",
            width: 100,
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        placement="bottomRight"
                        menu={{
                            items: [
                                {
                                    key: "2",
                                    label: (
                                        <p
                                            style={{ color: "grey", fontSize: "14px" }}
                                            onClick={() => exportWorkingTimeGroupReport(record)}
                                        >
                                            {t("action.download")}
                                        </p>
                                    ),
                                    icon: (
                                        <DownloadOutlined
                                            style={{ fontSize: "18px", color: "gray" }}
                                            onClick={() => exportWorkingTimeGroupReport(record)}
                                        />
                                    ),
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        }
    ];
    const columns2 = [
        {
            title: <div className="text-table">{t('common.index')}</div>,
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 100,
            render: (_, record, idx) => {
                console.log("dddd", _, record);
                return <span style={{ color: "#667085" }}>{(pagination2.pageNo - 1) * pagination2.size + idx + 1}</span>;
            },
        },
        {
            title: <div className="text-table">{t('employee.label.employee_id')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "center",
            width: 150,
            render: (_, record) => {
                return record.employeeInfo.employeeNo;
            },
        },
        {
            title: <div className="text-table">{t('employee.label.name')}</div>,
            dataIndex: "employeeInfo",
            key: "employeeInfo",
            align: "center",
            width: 150,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record.employeeInfo.employeeFullNameEn;
                }
                return record.employeeInfo.employeeFullName;
            },

        },
        {
            title: <div className="text-table">{t('workin_location.label.department')}</div>,
            dataIndex: "departmentModel",
            key: "departmentModel",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.departmentModel?.nameEn ? record?.departmentModel?.nameEn : "-";
                }
                return record?.departmentModel?.name ? record?.departmentModel?.name : "";
            },
        },
        {
            title: <div className="text-table">{t('position.header')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.position?.nameEn ? record?.position?.nameEn : "-";
                }
                return record?.position?.name ? record?.position?.name : "";
            },

        },

        {
            title: <div className="text-table">{t('branch.entity')}</div>,
            dataIndex: "branchInformation",
            key: "branchInformation",
            align: "left",
            width: 150,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.branchInformation?.nameEn;
                }
                return record?.branchInformation?.name;

            },
        },
        {
            title: "",
            key: "action",
            align: "center",
            width: 100,
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        placement="bottomRight"
                        menu={{
                            items: [
                                {
                                    key: "2",
                                    label: (
                                        <p
                                            style={{ color: "grey", fontSize: "14px" }}
                                            onClick={() => exportWorkingTimeGroupReport(record)}
                                        >
                                            {t("action.download")}
                                        </p>
                                    ),
                                    icon: (
                                        <DownloadOutlined
                                            style={{ fontSize: "18px", color: "gray" }}
                                            onClick={() => exportWorkingTimeGroupReport(record)}
                                        />
                                    ),
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        }
    ];
    const scrollX = columns.reduce((sum, column) => sum + (column.width || 0), 0);
    return (

        <MainLayout>
            <WorkingTimeModal name={t("time_stamp_report.header")} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} exportWorkingTimeGroupReport={exportWorkingTimeGroupReportAll} isDownloading={isDownloading} exportTimeAttendanceReport={exportTimeAttendanceReport} isDownloadingTA={isDownloadingTA} />
            <Space style={{ width: "100%", rowGap: 24 }} direction="vertical" >
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t('report.header'), href: "" },
                        { title: t('working_time_group.header'), href: "" },
                        { title: t('time-stamp-report') }
                    ]} />
                    <h2>{t('time-stamp-report')}</h2>
                </Flex>
                <FormAntd
                    // form={form}
                    initialValues={{ ...initialValues }}
                    onFinish={handleSearch}
                // requiredMark={RequiredMark}
                // colon={false}
                >
                    <FormItem shouldUpdate={(prev, curv) => {

                        return false
                    }}>

                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical style={{ rowGap: "24px" }}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t('warning_letter.label.employee')}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        multiple={true}
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                        tree={true}
                                                    // onChange={handleChange}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="positionId"
                                                        multiple={true}
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        // onChange={handleChange}
                                                        size="large"
                                                        tree={true}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        required
                                                        name="workingTimeDate"
                                                        type="range"
                                                        label={t('start-date-to-end-date')}
                                                        // allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('start-date-to-end-date')}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="branchId"
                                                        multiple={true}
                                                        mode={"multiple"}
                                                        label={t('branch.entity')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        // onChange={handleChange}
                                                        options={workInLocationList}
                                                        size="large"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                                {/* <Flex>
                                                    <Button
                                                        style={{ backgroundColor: "green", color: "#ffff" }} onClick={() => { exportWorkingTimeGroupReport() }}>EXCEL</Button>
                                                </Flex>
                                                <Flex>
                                                    <Button
                                                        style={{ backgroundColor: "green", color: "#ffff" }}>Text</Button>
                                                </Flex>
                                                <Flex>
                                                    <Button style={{ backgroundColor: "var(--button-color)", color: "#ffff" }} htmlType="submit">{t("search")}</Button>
                                                </Flex> */}

                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>
                                    {showReport && (
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                    <Flex gap={8}>
                                                        <DownloadICon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>
                                            <Card style={{
                                                backgroundColor: "white",
                                                width: "100%",
                                                border: "1px solid #EAECF0",
                                            }}>
                                                <Tabs destroyInactiveTabPane={true} tabBarStyle={{ justifyContent: 'space-between' }}>
                                                    <Tabs.TabPane tab={t('employee_list.entity')} key={2} >
                                                        <Space direction="vertical" size={8} style={{ width: "100%" }}>
                                                            <span style={{ fontWeight: "bold" }}>{t('time-stamp-report')}</span>
                                                            <TableAntd
                                                                onChange={onChange2}
                                                                pagination={pagination2}
                                                                columns={columns2}
                                                                dataSource={reportTableWoringTime2}
                                                                rowKey={(record) => record.id}
                                                                scroll={{ x: scrollX }}
                                                                tableLayout="fixed"
                                                            />
                                                        </Space>
                                                    </Tabs.TabPane>
                                                    <Tabs.TabPane tab={t('time-stamp-report')} key={1} >
                                                        <Space direction="vertical" size={8} style={{ width: "100%" }}>
                                                            <span style={{ fontWeight: "bold" }}>{t('time-stamp-report')}</span>
                                                            <TableAntd
                                                                onChange={onChange}
                                                                pagination={pagination}
                                                                columns={columns}
                                                                dataSource={reportTableWoringTime}
                                                                rowKey={(record) => record.id}
                                                                scroll={{ x: scrollX }}
                                                                tableLayout="fixed"
                                                            />
                                                        </Space>
                                                    </Tabs.TabPane>
                                                </Tabs>
                                            </Card>
                                        </Space>
                                    )}
                                </>
                            )
                        }}

                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    );
}

export default WorkingTimeGroupComponent;